/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TenantPublicSettings } from './tenantPublicSettings';

export type GenericApiResponseTenantPublicSettingsData = TenantPublicSettings | null;
